//set dynamicImports property on InternationalizationProvider for dynamic imports

export function en() {
    return import('./en').then(res => res.default)
}

export function pt() {
    return import('./pt').then(res => res.default)
}